export const QuestionMarkIcon = (props) => (
    <svg
        width={9}
        height={12}
        viewBox="0 0 9 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                d="M5.062.053C3.4.053 2.322.756 1.477 2.01a.527.527 0 0 0 .108.706l.898.703a.49.49 0 0 0 .693-.089c.522-.674.91-1.062 1.724-1.062.641 0 1.434.425 1.434 1.066 0 .484-.388.733-1.02 1.1-.739.426-1.715.957-1.715 2.285v.21c0 .285.223.516.5.516h1.51c.276 0 .5-.23.5-.516v-.124c0-.92 2.61-.959 2.61-3.45 0-1.877-1.888-3.3-3.657-3.3m-.208 8.024c-.796 0-1.444.668-1.444 1.488s.648 1.489 1.444 1.489 1.443-.668 1.443-1.489c0-.82-.648-1.488-1.443-1.488"
                fill="#3CBA9C"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M.854.053h8v11h-8z" />
            </clipPath>
        </defs>
    </svg>
);

export const RightAnswerIcon = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={8.072} cy={7.915} r={6.85} stroke="#2DE538" strokeWidth={1.3} />
        <path
            d="m4.842 8.126 2.1 1.968 4.359-4.358"
            stroke="#2DE538"
            strokeWidth={1.3}
            strokeLinecap="round"
        />
    </svg>
);

export const WrongAnswerIcon = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={8.18} cy={7.915} r={6.85} stroke="#FF3806" strokeWidth={1.3} />
        <path
            d="m5.58 10.514 5.199-5.199m0 5.199L5.58 5.315"
            stroke="#FF3806"
            strokeWidth={1.3}
            strokeLinecap="round"
        />
    </svg>
);
export const BackIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={22}
        height={23}
        viewBox="0 0 16 17"
        fill="none"
    >
        <g clipPath="url(#clip0_14_8591)">
            <path
                d="M3.22935 9.23054H8.20601C8.60754 9.23054 8.93307 8.90501 8.93307 8.50348C8.93307 8.10195 8.60754 7.77642 8.20601 7.77642H3.22935L4.16939 6.83638C4.45333 6.55244 4.45333 6.09211 4.16939 5.80817C3.8855 5.52423 3.42513 5.52423 3.14118 5.80817L0.960099 7.9893C0.943086 8.00632 0.926994 8.02415 0.911774 8.04277C0.905133 8.05086 0.899365 8.05944 0.893113 8.06773C0.885115 8.07839 0.876875 8.08881 0.869459 8.09991C0.862673 8.11004 0.856808 8.12056 0.850604 8.13094C0.844642 8.14092 0.838389 8.15066 0.832912 8.16094C0.827192 8.1716 0.822394 8.18256 0.817256 8.19341C0.812215 8.20403 0.806932 8.2145 0.802424 8.22536C0.798061 8.23597 0.794475 8.24678 0.790645 8.25754C0.786429 8.26917 0.781969 8.28066 0.778382 8.29254C0.775135 8.3033 0.77276 8.3142 0.770045 8.32511C0.766992 8.33718 0.763599 8.3492 0.761175 8.36151C0.758703 8.37406 0.757201 8.38676 0.755407 8.39941C0.753856 8.41022 0.751772 8.42089 0.750706 8.43184C0.748379 8.4553 0.747167 8.47891 0.747119 8.50246L0.74707 8.50353L0.747119 8.5046C0.747167 8.5282 0.748379 8.55176 0.750706 8.57527C0.751772 8.58607 0.753808 8.59659 0.75531 8.60731C0.757152 8.6201 0.758655 8.6329 0.761175 8.6456C0.763599 8.65781 0.766943 8.66964 0.769997 8.68161C0.77276 8.69261 0.775183 8.70371 0.778479 8.71462C0.782018 8.7263 0.786429 8.73759 0.7905 8.74903C0.794426 8.75999 0.798013 8.77099 0.802472 8.78175C0.806883 8.79241 0.81207 8.80264 0.817014 8.81306C0.822248 8.82416 0.827192 8.83536 0.833009 8.84627C0.838341 8.8562 0.844399 8.86565 0.850167 8.8753C0.856517 8.88601 0.862576 8.89682 0.869556 8.90724C0.876633 8.91786 0.884533 8.92779 0.892143 8.93802C0.898735 8.94679 0.904842 8.95586 0.911871 8.96439C0.926363 8.98203 0.941729 8.99895 0.957772 9.01519L0.959954 9.01761L3.14114 11.1988C3.28315 11.3408 3.46918 11.4118 3.65526 11.4118C3.84129 11.4118 4.02742 11.3408 4.16934 11.1989C4.45329 10.9149 4.45329 10.4546 4.16939 10.1707L3.22935 9.23054Z"
                fill="#1C1C64"
            />
            <path
                d="M14.7766 1.95996H5.56715C5.16562 1.95996 4.84009 2.28549 4.84009 2.68702V5.59526C4.84009 5.99679 5.16562 6.32232 5.56715 6.32232C5.96868 6.32232 6.29421 5.99679 6.29421 5.59526V3.41408H14.0495V13.593H6.29421V11.4117C6.29421 11.0102 5.96868 10.6847 5.56715 10.6847C5.16562 10.6847 4.84009 11.0102 4.84009 11.4117V14.32C4.84009 14.7216 5.16562 15.0471 5.56715 15.0471H14.7766C15.1781 15.0471 15.5036 14.7216 15.5036 14.32V2.68702C15.5036 2.28549 15.1781 1.95996 14.7766 1.95996Z"
                fill="#1C1C64"
            />
        </g>
        <defs>
            <clipPath id="clip0_14_8591">
                <rect
                    width="15.5107"
                    height="15.5107"
                    fill="white"
                    transform="translate(-0.00708008 0.748047)"
                />
            </clipPath>
        </defs>
    </svg>

);